// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

body {
    margin: 0;
    padding: 0;
    text-align: center;
    color: #2A2A2A;
    background-color: #fff;
    font-family: Tahoma, sans-serif;
    font-size: .92857143em;
    font-weight: 400;
}

h1, h2, h3, h4, h5 {
    font-weight: 400;
    font-family: Tahoma, sans-serif;
}

h1 b, h2 b, h3 b, h4 b, h5 b {
    font-weight: 400;
}

b {
    font-weight: 400;
}

a {
    color: #2A2A2A;
}

a:hover {
    text-decoration: none;
    color: #000000;
}

.mb-0 {
    margin-bottom: 0 !important;
}

.mt-4 {
    margin-top: 40px !important;
}

.my-4 {
    margin: 40px auto 40px auto;
}

.home-image {
    vertical-align: middle;
    margin-bottom: 50px;
}

.home-image .logo {
    width: 150px;
    vertical-align: middle;
}

.home-image .logo-plus {
    display: inline-block;
    font-size: 50px;
    margin: 0 15px 0 30px;
    vertical-align: middle;
}

img.logo-image {
    width: 200px;
    margin-top: 100px;
}

code {
    background: #272822;
    padding: 4px;
    font-size: 90%;
    color: #fd971f;
}

.code {
    background: #272822;
    display: block;
    word-break: break-all;
    padding: 20px;
    text-align: left;
    border-radius: 4px;
}

.code .id-token-0 {
    color: #cc6633;
}

.code .id-token-1 {
    color: #f9f8f5;
}

.code .id-token-2 {
    color: #fd971f;
}

.row {
    width: 100%;
    display: flex;
    text-align: left;
}

.row>.column {
    flex: 40%;
    margin-right: 15px;
}

.row>.column:last-child {
    flex: 60%;
    margin-right: 0;
}

.error-page_h6 {
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 400;
    margin-top: 3rem;
    margin-bottom: 8px;
    color: #151515;
}

.error-page_p {
    font-size: 20px;
    font-weight: 400;
    margin-top: 3rem;
    margin-bottom: 3rem;
    color: #151515;
}

@media screen and (max-width: 600px) {
    .column {
        width: 100%;
        margin-right: 0;
    }
}

.container {
    background: #fff;
    border: 1px solid #e2e2e2;
    width: 980px;
    margin: 0 auto;
    margin-top: 50px;
    border-radius: 10px;
}

.json {
    text-align: left;
    display: block;
    overflow: auto;
    word-break: break-all;
}

.json .pretty-json-container.object-container {
    padding: 20px;
}

.header-title {
    background-color: #386980;
    color: #ffffff;
    padding: 20px;
    border-radius: 10px 10px 0 0;
}

.header-title h1 {
    font-size: 1.57142857rem;
}

.content {
    padding: 50px;
}

.content .spa-app-description {
    line-height: 1.7;
    font-size: .92857143em;
}

.btn.primary, .btn.primary:active, .btn.primary:focus {
    font-family: Tahoma, sans-serif;
    background-color: #38a680;
    border-radius: 3px;
    border: none;
    color: #ffffff;
    display: inline-block;
    font-size: 1.14285714rem;
    text-align: center;
    text-decoration: none;
    width: auto;
    cursor: pointer;
    -webkit-text-size-adjust: none;
    padding: .78571429em 1.5em .78571429em;
    margin-top: 30px;
    outline: none;
}

.btn.primary:hover {
    background: #38a680 !important;
    filter: brightness(0.85);
}

.sub-title {
    margin-top: 0;
}

.inline-code-block {
    border-radius: 6px;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    padding: 3px 5px;
    border: 1px solid #cdcdcd;
    background-color: white;
    font-family: Monaco, Consolas, "Andale  Mono", "DejaVu Sans Mono", monospace;
}

.inline-code-block a {
    text-decoration: none !important;
}

.pointer {
    cursor: pointer;
}

.ui.attached.negative.message,
.ui.negative.message {
    background-color: #fff6f6;
    color: #9f3a38;
    box-shadow: 0 0 0 1px #e0b4b4 inset, 0 0 0 0 transparent;
    padding: 1em 1.5em;
}

.asg-json-viewer {
    background-color: #272822 !important;
    padding: 20px;
}

.incountry-logo-image.logo {
    width: 200px;
    height: auto;
    vertical-align: middle;
    filter: brightness(0) saturate(100%) invert(16%) sepia(0%) saturate(11%) hue-rotate(253deg) brightness(97%) contrast(88%);
}

.asgardeo-logo-image.logo {
    width: 200px;
    height: auto;
    vertical-align: middle;
}

.footer-spacing {
    margin: 30px auto;
}

.logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-bottom: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;EAgBE;;AAEF;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,sCAAsC;IACtC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,4EAA4E;AAChF;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,wDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,yHAAyH;AAC7H;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB","sourcesContent":["/**\n * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.\n *\n * WSO2 Inc. licenses this file to you under the Apache License,\n * Version 2.0 (the \"License\"); you may not use this file except\n * in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing,\n * software distributed under the License is distributed on an\n * \"AS IS\" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY\n * KIND, either express or implied. See the License for the\n * specific language governing permissions and limitations\n * under the License.\n */\n\nbody {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n    color: #2A2A2A;\n    background-color: #fff;\n    font-family: Tahoma, sans-serif;\n    font-size: .92857143em;\n    font-weight: 400;\n}\n\nh1, h2, h3, h4, h5 {\n    font-weight: 400;\n    font-family: Tahoma, sans-serif;\n}\n\nh1 b, h2 b, h3 b, h4 b, h5 b {\n    font-weight: 400;\n}\n\nb {\n    font-weight: 400;\n}\n\na {\n    color: #2A2A2A;\n}\n\na:hover {\n    text-decoration: none;\n    color: #000000;\n}\n\n.mb-0 {\n    margin-bottom: 0 !important;\n}\n\n.mt-4 {\n    margin-top: 40px !important;\n}\n\n.my-4 {\n    margin: 40px auto 40px auto;\n}\n\n.home-image {\n    vertical-align: middle;\n    margin-bottom: 50px;\n}\n\n.home-image .logo {\n    width: 150px;\n    vertical-align: middle;\n}\n\n.home-image .logo-plus {\n    display: inline-block;\n    font-size: 50px;\n    margin: 0 15px 0 30px;\n    vertical-align: middle;\n}\n\nimg.logo-image {\n    width: 200px;\n    margin-top: 100px;\n}\n\ncode {\n    background: #272822;\n    padding: 4px;\n    font-size: 90%;\n    color: #fd971f;\n}\n\n.code {\n    background: #272822;\n    display: block;\n    word-break: break-all;\n    padding: 20px;\n    text-align: left;\n    border-radius: 4px;\n}\n\n.code .id-token-0 {\n    color: #cc6633;\n}\n\n.code .id-token-1 {\n    color: #f9f8f5;\n}\n\n.code .id-token-2 {\n    color: #fd971f;\n}\n\n.row {\n    width: 100%;\n    display: flex;\n    text-align: left;\n}\n\n.row>.column {\n    flex: 40%;\n    margin-right: 15px;\n}\n\n.row>.column:last-child {\n    flex: 60%;\n    margin-right: 0;\n}\n\n.error-page_h6 {\n    font-size: 30px;\n    text-transform: uppercase;\n    font-weight: 400;\n    margin-top: 3rem;\n    margin-bottom: 8px;\n    color: #151515;\n}\n\n.error-page_p {\n    font-size: 20px;\n    font-weight: 400;\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n    color: #151515;\n}\n\n@media screen and (max-width: 600px) {\n    .column {\n        width: 100%;\n        margin-right: 0;\n    }\n}\n\n.container {\n    background: #fff;\n    border: 1px solid #e2e2e2;\n    width: 980px;\n    margin: 0 auto;\n    margin-top: 50px;\n    border-radius: 10px;\n}\n\n.json {\n    text-align: left;\n    display: block;\n    overflow: auto;\n    word-break: break-all;\n}\n\n.json .pretty-json-container.object-container {\n    padding: 20px;\n}\n\n.header-title {\n    background-color: #386980;\n    color: #ffffff;\n    padding: 20px;\n    border-radius: 10px 10px 0 0;\n}\n\n.header-title h1 {\n    font-size: 1.57142857rem;\n}\n\n.content {\n    padding: 50px;\n}\n\n.content .spa-app-description {\n    line-height: 1.7;\n    font-size: .92857143em;\n}\n\n.btn.primary, .btn.primary:active, .btn.primary:focus {\n    font-family: Tahoma, sans-serif;\n    background-color: #38a680;\n    border-radius: 3px;\n    border: none;\n    color: #ffffff;\n    display: inline-block;\n    font-size: 1.14285714rem;\n    text-align: center;\n    text-decoration: none;\n    width: auto;\n    cursor: pointer;\n    -webkit-text-size-adjust: none;\n    padding: .78571429em 1.5em .78571429em;\n    margin-top: 30px;\n    outline: none;\n}\n\n.btn.primary:hover {\n    background: #38a680 !important;\n    filter: brightness(0.85);\n}\n\n.sub-title {\n    margin-top: 0;\n}\n\n.inline-code-block {\n    border-radius: 6px;\n    -moz-border-radius: 6px;\n    -webkit-border-radius: 6px;\n    padding: 3px 5px;\n    border: 1px solid #cdcdcd;\n    background-color: white;\n    font-family: Monaco, Consolas, \"Andale  Mono\", \"DejaVu Sans Mono\", monospace;\n}\n\n.inline-code-block a {\n    text-decoration: none !important;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.ui.attached.negative.message,\n.ui.negative.message {\n    background-color: #fff6f6;\n    color: #9f3a38;\n    box-shadow: 0 0 0 1px #e0b4b4 inset, 0 0 0 0 transparent;\n    padding: 1em 1.5em;\n}\n\n.asg-json-viewer {\n    background-color: #272822 !important;\n    padding: 20px;\n}\n\n.incountry-logo-image.logo {\n    width: 200px;\n    height: auto;\n    vertical-align: middle;\n    filter: brightness(0) saturate(100%) invert(16%) sepia(0%) saturate(11%) hue-rotate(253deg) brightness(97%) contrast(88%);\n}\n\n.asgardeo-logo-image.logo {\n    width: 200px;\n    height: auto;\n    vertical-align: middle;\n}\n\n.footer-spacing {\n    margin: 30px auto;\n}\n\n.logo-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 30px;\n    margin-bottom: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
